import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {},

  // model
  serviceModel: [],
  linkedCmsMstModel: []
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, userParams, serviceParams, linkedCmsMstParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = ['linkedCmsMst']
      const methods = ['v1LinkedCmsMstListGet']
      const parameters = [linkedCmsMstParams]

      if (getters.isModify(state)) {
        types.push('user')
        methods.push('v1UserDetailGet')
        parameters.push(userParams)
      }

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push(serviceParams)
      }

      if (getters.isRegister(state)) {
        // データを読出し
        ApiManager.request(types, methods, parameters)
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('inited', {})
              commit('setCmsModel', res[0].data.linkedCmsMsts)
              console.log('linkedCmsMstModel', state.linkedCmsMstModel)
              if (isAdmin) {
                commit('setServiceModel', res[1].data.serviceInfo)
                console.log('serviceModel', state.serviceModel)
              }
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })

      } else {
        // データを読出し
        ApiManager.request(types, methods, parameters)
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setCmsModel', res[0].data.linkedCmsMsts)
              console.log('linkedCmsMstModel', state.linkedCmsMstModel)
              commit('inited', res[1].data)
              console.log('values', state.values)
              if (isAdmin) {
                commit('setServiceModel', res[2].data.serviceInfo)
                console.log('serviceModel', state.serviceModel)
              }
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
      }
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpName', data.name || null)
    Vue.set(state.values, 'inpEmail', data.email || null)
    Vue.set(state.values, 'inpRoleKbn', data.roleKbn || '')
    let service = data.service ? data.service.serviceUuid : ''
    Vue.set(state.values, 'inpService', service)
    let cmsList = []
    if (data.linkedCmss) {
      try {
        cmsList = data.linkedCmss.map(item => item.linkedCmsMstUuid)
      /* eslint-disable no-new */
      } catch (e) {
        console.log(e)
      }
    }
    console.log('cmsList', cmsList)
    Vue.set(state.values, 'inpCmsList', cmsList)
    Vue.set(state.values, 'inpStatus', data.status)
  },

  // model
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },
  setCmsModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'linkedCmsMstModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
